import { supabase } from "../supabaseClient";

/**
 * Returns the exact password reset redirect URL.
 * In production, validates that the redirect target pathname is strictly `/reset-password`.
 */
export function getPasswordResetRedirectUrl(): string {
  const isBrowser = typeof window !== "undefined" && Boolean(window.location?.origin);

  let baseUrl: string;
  if (isBrowser) {
    baseUrl = window.location.origin;
  } else {
    baseUrl = process.env.PUBLIC_APP_URL || process.env.APP_URL || "https://getbiznearyou.com";
  }

  const url = new URL("/reset-password", baseUrl);
  const redirectUrl = url.toString();

  // Development diagnostic logging
  if (process.env.NODE_ENV !== "production") {
    console.debug("[Password Recovery] redirect pathname:", url.pathname);
  }

  if (process.env.NODE_ENV === "production") {
    if (url.pathname !== "/reset-password") {
      throw new Error(`Invalid production password-reset redirect: ${redirectUrl}`);
    }
  }

  return redirectUrl;
}

/**
 * Sends a password reset email to the specified user address.
 * Guarantees that `redirectTo` points to `/reset-password`.
 */
export async function sendPasswordResetEmail(email: string): Promise<{ success: boolean; message: string }> {
  const trimmedEmail = email.trim();
  if (!trimmedEmail) {
    throw new Error("A valid email address is required.");
  }

  const redirectUrl = getPasswordResetRedirectUrl();

  const { error } = await supabase.auth.resetPasswordForEmail(trimmedEmail, {
    redirectTo: redirectUrl,
  });

  if (error) {
    throw error;
  }

  return {
    success: true,
    message: `Password reset link sent to ${trimmedEmail}`,
  };
}
